class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.onLowerBoundInputChangeListener = this.onLowerBoundInputChange.bind(this);
    this.onHigherBoundInputChangeListener = this.onHigherBoundInputChange.bind(this);

    this.onLowerBoundRangeChangeListener = this.onLowerBoundRangeChange.bind(this);
    this.onHigherBoundRangeChangeListener = this.onHigherBoundRangeChange.bind(this);

    this.onLowerBoundRangeInputListener = this.onLowerBoundRangeInput.bind(this);
    this.onHigherBoundRangeInputListener = this.onHigherBoundRangeInput.bind(this);
  }

  get selectors() {
    return {
      range: {
        group: "[data-range-group]",
        lowerBound: "[data-action='update-min-range']",
        higherBound: "[data-action='update-max-range']"
      },
      input: {
        lowerBound: "[data-action='update-min-input']",
        higherBound: "[data-action='update-max-input']"
      }
    }
  }

  connectedCallback() {
    this.inputLowerBoundElement = this.querySelector(this.selectors.input.lowerBound);
    this.inputHigherBoundElement = this.querySelector(this.selectors.input.higherBound);

    this.rangeGroupElement = this.querySelector(this.selectors.range.group);

    this.rangeLowerBoundElement = this.querySelector(this.selectors.range.lowerBound);
    this.rangeHigherBoundElement = this.querySelector(this.selectors.range.higherBound);

    this.inputLowerBoundElement.addEventListener("change", this.onLowerBoundInputChangeListener);
    this.inputHigherBoundElement.addEventListener("change", this.onHigherBoundInputChangeListener);

    this.rangeLowerBoundElement.addEventListener("change", this.onLowerBoundRangeChangeListener);
    this.rangeHigherBoundElement.addEventListener("change", this.onHigherBoundRangeChangeListener);

    this.rangeLowerBoundElement.addEventListener("input", this.onLowerBoundRangeInputListener);
    this.rangeHigherBoundElement.addEventListener("input", this.onHigherBoundRangeInputListener);
  }

  disconnectedCallback() {
    this.inputLowerBoundElement.removeEventListener("change", this.onLowerBoundInputChangeListener);
    this.inputHigherBoundElement.removeEventListener("change", this.onHigherBoundInputChangeListener);

    this.rangeLowerBoundElement.removeEventListener("change", this.onLowerBoundRangeChangeListener);
    this.rangeHigherBoundElement.removeEventListener("change", this.onHigherBoundRangeChangeListener);

    this.rangeLowerBoundElement.removeEventListener("input", this.onLowerBoundRangeInputListener);
    this.rangeHigherBoundElement.removeEventListener("input", this.onHigherBoundRangeInputListener);
  }

  onLowerBoundInputChange(event) {
    event.preventDefault();

    this.setLowerBoundValue(event.target);
  }

  onHigherBoundInputChange(event) {
    event.preventDefault();

    this.setHigherBoundValue(event.target);
  }

  onLowerBoundRangeChange(event) {
    event.stopPropagation();

    this.inputLowerBoundElement.value = parseInt(event.target.value);
    this.inputLowerBoundElement.dispatchEvent(new Event("change", {
      bubbles: true
    }));
  }

  onHigherBoundRangeChange(event) {
    event.stopPropagation();

    this.inputHigherBoundElement.value = parseInt(event.target.value);
    this.inputHigherBoundElement.dispatchEvent(new Event("change", {
      bubbles: true
    }));
  }

  onLowerBoundRangeInput(event) {
    this.setLowerBoundValue(event.target);
  }

  onHigherBoundRangeInput(event) {
    this.setHigherBoundValue(event.target);
  }

  setLowerBoundValue(element) {
    const currentValue = parseInt(element.value);
    const maxValue = parseInt(this.inputHigherBoundElement.value || element.max) - 1;

    const newValue = Math.min(currentValue, maxValue);

    this.inputLowerBoundElement.value = newValue;
    this.rangeLowerBoundElement.value = newValue;

    this.setMinRangeProgress();
  }

  setHigherBoundValue(element) {
    const currentValue = parseInt(element.value);
    const minValue = parseInt(this.inputLowerBoundElement.value || element.min) + 1;

    const newValue = Math.max(currentValue, minValue);

    this.inputHigherBoundElement.value = newValue;
    this.rangeHigherBoundElement.value = newValue;

    this.setMaxRangeProgress();
  }

  setMinRangeProgress() {
    this.rangeGroupElement.style.setProperty(
      "--range-track-min", `${parseInt(this.rangeLowerBoundElement.value) / parseInt(this.rangeLowerBoundElement.max) * 100}%`
    );
  }

  setMaxRangeProgress() {
    this.rangeGroupElement.style.setProperty(
      "--range-track-max", `${parseInt(this.rangeHigherBoundElement.value) / parseInt(this.rangeHigherBoundElement.max) * 100}%`
    );
  }
}

if (!customElements.get("price-range")) {
  customElements.define("price-range", PriceRange);
}

class ProductSort extends HTMLElement {
  constructor() {
    super();

    this.onSelectChangedListener = this.onSelectChange.bind(this);
  }

  get selectors() {
    return {
      select: "select"
    }
  }

  get attributes() {
    return {
      sectionId: "data-section-id"
    }
  }

  connectedCallback() {
    this.selectElement = this.querySelector(this.selectors.select);

    if (!this.selectElement) {
      return;
    }

    this.selectElement.addEventListener("change", this.onSelectChangedListener);
  }

  disconnectedCallback() {
    this.selectElement.removeEventListener("change", this.onSelectChangedListener);
  }

  onSelectChange(event) {
    const url = this.buildFacetedUrl(event.target.value);

    this.dispatchEvent(new CustomEvent("filter:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }

  buildFacetedUrl(value) {
    const url = new URL(location.href);

    url.searchParams.set("sort_by", value);
    url.searchParams.set("section_id", this.selectElement.getAttribute(this.attributes.sectionId));

    url.searchParams.delete("page");

    return url;
  }
}

if (!customElements.get("product-sort")) {
  customElements.define("product-sort", ProductSort);
}

window.openedFilterTreeAccordions = new Set();
window.initializedDefaultFilterTrees = new Set();

window.filterTreeUpdateCount = 0;

document.addEventListener("filter:update", async (event) => {
  const selectors = {
    shopifySection: ".shopify-section",
    accordion: "base-accordion"
  };

  const modifiers = {
    loading: "loading"
  };

  const url = event?.detail?.url;

  if (!url) {
    return;
  }

  const shopifySectionId = url.searchParams.get("section_id");
  const shopifySection = document.getElementById(`shopify-section-${shopifySectionId}`);

  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id");

  history.replaceState({}, "", clonedUrl.toString());

  shopifySection.classList.add(modifiers.loading);

  try {
    const response = await window.cachedFetch(url.toString(), false);

    const sectionContent = new DOMParser().parseFromString(response.toString(), "text/html");

    const accordions = [...sectionContent.querySelectorAll(selectors.accordion)];

    accordions.forEach((accordion) => {
      if (window.openedFilterTreeAccordions.has(accordion.id)) {
        accordion.setAttribute("open", "");
      }
    });

    shopifySection.replaceChildren(...document.importNode(sectionContent.querySelector(selectors.shopifySection), true).childNodes);

    shopifySection.classList.remove(modifiers.loading);

    if ((window.filterTreeUpdateCount - 1) > 0) {
      shopifySection.scrollIntoView({ block: "start", behavior: "smooth" });
    }

    window.filterTreeUpdateCount++;
  } catch (error) {
    console.error(error);
  }
});

class FilterTree extends HTMLElement {
  constructor() {
    super();

    this.onFormChangedListener = this.onFormChange.bind(this);
    this.onFormSubmittedListener = this.onFormSubmit.bind(this);
  }

  get selectors() {
    return {
      form: "form",
      input: "input",
      accordion: "base-accordion"
    }
  }

  get attributes() {
    return {
      updateOnChange: "data-update-on-change",
      sectionId: "data-section-id",
      input: {
        checkedOnLoad: "data-checked-on-load"
      }
    }
  }

  get inputsWithDefaultValues() {
    return [...this.formElement.querySelectorAll(`${this.selectors.input}[${this.attributes.input.checkedOnLoad}="true"]`)];
  }

  get shouldUpdateOnChange() {
    return this.formElement.getAttribute(this.attributes.updateOnChange) === "true";
  }

  get shouldInitDefaultValues() {
    return this.inputsWithDefaultValues.length > 0;
  }

  connectedCallback() {
    this.formElement = this.querySelector(this.selectors.form);

    if (!this.formElement) {
      return;
    }

    this.formElement.addEventListener("change", this.onFormChangedListener);
    this.formElement.addEventListener("submit", this.onFormSubmittedListener);

    this.extractOpenedAccordions();
    this.initDefaultValues();
  }

  disconnectedCallback() {
    this.formElement.removeEventListener("change", this.onFormChangedListener);
    this.formElement.removeEventListener("submit", this.onFormSubmittedListener);
  }

  onFormChange() {
    if (this.shouldUpdateOnChange) {
      this.formElement.dispatchEvent(new Event("submit", { cancelable: true }));
    }
  }

  onFormSubmit(event) {
    event.preventDefault();

    const url = this.buildFacetedUrl();

    this.dispatchEvent(new CustomEvent("filter:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }

  buildFacetedUrl() {
    const formData = new FormData(this.formElement);
    const formDataSearchParams = [...formData];

    const searchParams = new URLSearchParams(formDataSearchParams);

    const url = new URL(this.formElement.action);

    url.search = "";

    searchParams.forEach((value, key) =>
      url.searchParams.append(key, value)
    );

    ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((parameterToClear) => {
      if (url.searchParams.get(parameterToClear) === "") {
        url.searchParams.delete(parameterToClear);
      }
    });

    url.searchParams.set("section_id", this.formElement.getAttribute(this.attributes.sectionId));

    return url;
  }

  initDefaultValues() {
    if (this.shouldInitDefaultValues && !window.initializedDefaultFilterTrees.has(this.formElement.id)) {
      this.inputsWithDefaultValues.forEach((input) =>
        input.checked = true
      );

      this.formElement.dispatchEvent(new Event("submit", { cancelable: true }));
    }

    window.initializedDefaultFilterTrees.add(this.formElement.id);
  }

  extractOpenedAccordions() {
    const accordions = [...this.querySelectorAll(this.selectors.accordion)];

    if (!accordions.length) {
      return;
    }

    accordions.forEach((accordion) => {
      if (accordion.open) {
        window.openedFilterTreeAccordions.add(accordion.id);
      }

      accordion.addEventListener("accordion:toggle", () => {
        if (accordion.open) {
          window.openedFilterTreeAccordions.add(accordion.id);
        } else {
          window.openedFilterTreeAccordions.delete(accordion.id);
        }
      });
    });
  }
}

if (!customElements.get("filter-tree")) {
  customElements.define("filter-tree", FilterTree);
}

class FilterLink extends HTMLAnchorElement {
  constructor() {
    super();

    this.onLinkClickedListener = this.onLinkClick.bind(this);

    this.addEventListener("click", this.onLinkClickedListener);
  }

  onLinkClick(event) {
    event.preventDefault();

    const shopifySectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", "");

    const url = this.buildFacetedUrl(shopifySectionId);

    this.dispatchEvent(new CustomEvent("filter:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }

  buildFacetedUrl(sectionId) {
    const url = new URL(this.href);

    url.searchParams.set("section_id", sectionId);

    return url;
  }
}

if (!customElements.get("filter-link")) {
  customElements.define("filter-link", FilterLink, { extends: "a" });
}

class FilterApplyButton extends HTMLButtonElement {
  constructor() {
    super();

    this.filterFormElement = this.closest(this.selectors.form);
    this.onButtonClickedListener = this.onButtonClick.bind(this);

    this.addEventListener("click", this.onButtonClickedListener);
  }

  get selectors() {
    return {
      form: "form"
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    this.filterFormElement.dispatchEvent(new Event("submit", { cancelable: true }));
  }
}

if (!customElements.get("filter-apply-button")) {
  customElements.define("filter-apply-button", FilterApplyButton, { extends: "button" });
}
